export default __webpack_public_path__ + "media/images/icons_fc/calendar-07dccbebe9a2e2653d8bf4a872370d61.png";